module.exports = __webpack_public_path__ + "static/media/bibak-background.bf00dc02.png";